// import React, { useState, useEffect, useMemo } from "react";
// import Loader from "../../Shared/Loader";

// import "../../../css/AddStationsTable.css";
// import api from "../../../api/axiosConfig";
// import ConfigureStationModal from "./ConfigureStationModal";

// // --- Interfaces ---
// interface Station {
//   id: string;
//   appointmentId: string;
//   centerId: string;
//   centerName: string;
//   centerType: string;
//   city: string;
//   startDate: string;
//   endDate: string;
//   status: string;
//   slotDesigns: Record<string, string>;
// }

// interface SlotClusterItem {
//   _id: string;
//   appointment_cluster_id: string;
//   center_id: string;
//   start_date: string;
//   end_date: string;
//   weekday_template_map: Record<string, string>;
// }

// interface SlotClusterResponse {
//   page: number;
//   limit: number;
//   total: number;
//   items: SlotClusterItem[];
// }

// interface CenterDetails {
//   name: string;
//   centerType: string;
//   city: string;
// }

// interface ConfigResponse {
//   success: boolean;
//   data: {
//     _id: string;
//     status: string;
//   };
// }

// // NEW: Interface for the Template API response
// interface SlotTemplateResponse {
//   template: {
//     _id: string;
//     name: string;
//     created_on: string;
//   };
//   slots: any[]; // We don't need the specific slots details here, just the name
// }

// const AddStationsTable = () => {
//   const [stations, setStations] = useState<Station[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [error, setError] = useState<string | null>(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedStation, setSelectedStation] = useState<Station | null>(null);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     const fetchStationsData = async () => {
//       setLoading(true);
//       try {
//         const token = sessionStorage.getItem("accessToken");
//         if (!token) throw new Error("Authentication token not found.");

//         // 1. Get Clusters
//         const clusterRes = await api.appointment_api.get<SlotClusterResponse>("/api/cluster/clusters", {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const clusters: SlotClusterItem[] = clusterRes.data.items || [];

//         const uniqueCenterIds = Array.from(new Set(clusters.map(c => c.center_id)));

//         if (uniqueCenterIds.length === 0) {
//           setStations([]);
//           setLoading(false);
//           return;
//         }

//         // 2. Fetch Center Details and Config Status in Parallel
//         const centerDetailPromises = uniqueCenterIds.map(id =>
//           api.center_api.get<{ success: boolean, data: CenterDetails }>(`/api/v1/centers/${id}`, {
//             headers: { Authorization: `Bearer ${token}` }
//           })
//         );

//         const configPromises = uniqueCenterIds.map(async (id) => {
//           try {
//             const res = await api.center_api.get<ConfigResponse>(`/api/v1/center/${id}/config`, {
//               headers: { Authorization: `Bearer ${token}` }
//             });
//             if (res.data && res.data.data && res.data.data.status) {
//               return res.data.data.status;
//             }
//             return "Not Configured";
//           } catch (err) {
//             return "Not Configured";
//           }
//         });

//         const [centerResponses, configStatuses] = await Promise.all([
//           Promise.all(centerDetailPromises),
//           Promise.all(configPromises)
//         ]);

//         const centerDataMap = new Map<string, CenterDetails>();
//         centerResponses.forEach((res, i) => {
//           if (res.data?.success) {
//             centerDataMap.set(uniqueCenterIds[i], res.data.data);
//           }
//         });

//         const configStatusMap = new Map<string, string>();
//         configStatuses.forEach((status, i) => {
//           configStatusMap.set(uniqueCenterIds[i], status);
//         });

//         // 3. Fetch Template Names
//         const uniqueTemplateIds = new Set<string>();

//         clusters.forEach(cluster => {
//           if (cluster.weekday_template_map) {
//             Object.values(cluster.weekday_template_map).forEach(val => {
//               // Filter out "None" or empty strings
//               if (val && val !== "None" && val.length > 5) {
//                 uniqueTemplateIds.add(val);
//               }
//             });
//           }
//         });

//         const idToNameMap: Record<string, string> = {};

//         if (uniqueTemplateIds.size > 0) {
//           const templateIdsArray = Array.from(uniqueTemplateIds);
//           const templatePromises = templateIdsArray.map(id =>
//             api.appointment_api.get<SlotTemplateResponse>(`/api/slot-templates/${id}`, {
//               headers: { Authorization: `Bearer ${token}` }
//             }).catch(() => null)
//           );

//           const templateResponses = await Promise.all(templatePromises);

//           templateResponses.forEach((res, index) => {
//             const originalId = templateIdsArray[index];
//             if (res && res.data && res.data.template) {
//               idToNameMap[originalId] = res.data.template.name;
//             } else {
//               idToNameMap[originalId] = originalId;
//             }
//           });
//         }

//         // 4. Combine Data and Apply Names
//         const finalStationsData = clusters.map((cluster) => {
//           const centerItem = centerDataMap.get(cluster.center_id);
//           const statusItem = configStatusMap.get(cluster.center_id) || "Not Configured";

//           let rawSlotDesigns: Record<string, string> = {
//             Monday: "None", Tuesday: "None", Wednesday: "None",
//             Thursday: "None", Friday: "None", Saturday: "None", Sunday: "None",
//             ...(cluster.weekday_template_map || {})
//           };

//           const namedSlotDesigns: Record<string, string> = {};
//           Object.entries(rawSlotDesigns).forEach(([day, value]) => {
//             if (idToNameMap[value]) {
//               namedSlotDesigns[day] = idToNameMap[value];
//             } else {
//               namedSlotDesigns[day] = value;
//             }
//           });

//           return {
//             id: cluster._id,
//             appointmentId: cluster.appointment_cluster_id,
//             centerId: cluster.center_id,
//             centerName: centerItem?.name || "Unknown",
//             centerType: centerItem?.centerType || "Unknown",
//             city: centerItem?.city || "Unknown",
//             startDate: cluster.start_date,
//             endDate: cluster.end_date,
//             status: statusItem,
//             slotDesigns: namedSlotDesigns,
//           };
//         });

//         setStations(finalStationsData);
//       } catch (err: any) {
//         console.error("Failed to fetch stations data:", err);
//         setError(err.message || "Could not load station data.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStationsData();
//   }, []);

//   // ... (Filtering, Pagination, Render Logic remains exactly the same)

//   const filteredStations = useMemo(() => {
//     return stations.filter(
//       (station) =>
//         station.centerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         station.city.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [stations, searchTerm]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm]);

//   const totalPages = Math.ceil(filteredStations.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentStationsToDisplay = filteredStations.slice(startIndex, endIndex);

//   const handleRowClick = (station: Station) => {
//     setSelectedStation(station);
//     setIsModalOpen(true);
//   };
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedStation(null);
//   };

//   if (loading) return <div className="add-stations-container"><Loader text="Loading stations..." /></div>;
//   if (error) return <div className="add-stations-container"><p style={{ color: "red" }}>{error}</p></div>;

//   return (
//     <div className="add-stations-container">
//       <h3 className="add-station-table-title">List of Appointment Released</h3>
//       <div className="table-actions">
//         <div className="actions">
//           <input
//             type="text"
//             placeholder="Search by name or city..."
//             className="search-box"
//             style={{ paddingLeft: "30px" }}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>
//       </div>
//       <table className="add-stations-table">
//         <thead>
//           <tr>
//             <th>No.</th>
//             <th>Center Name</th>
//             <th>Center Type</th>
//             <th>City</th>
//             <th>Start Date</th>
//             <th>End Date</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentStationsToDisplay.length > 0 ? (
//             currentStationsToDisplay.map((row, index) => (
//               <tr key={row.id} onClick={() => handleRowClick(row)} style={{ cursor: 'pointer' }}>
//                 <td>{startIndex + index + 1}</td>
//                 <td>{row.centerName}</td>
//                 <td><span className={`badge ${row.centerType === "Qavach" ? "qavach" : "camp"}`}>{row.centerType}</span></td>
//                 <td>{row.city}</td>
//                 <td>{row.startDate}</td>
//                 <td>{row.endDate}</td>
//                 <td className={row.status === "Configured" ? "status-configured" : "status-not"}>{row.status}</td>
//               </tr>
//             ))
//           ) : (
//             <tr><td colSpan={7} style={{ textAlign: 'center' }}>No stations match your search.</td></tr>
//           )}
//         </tbody>
//       </table>

//       {totalPages > 0 && (
//         <div className="pagination-footer">
//           <p>Showing {startIndex + 1} to {Math.min(endIndex, filteredStations.length)} of {filteredStations.length} results</p>
//           <div className="pagination">
//             <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}>Previous</button>
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => (
//               <button key={pageNumber} onClick={() => setCurrentPage(pageNumber)} className={currentPage === pageNumber ? "active" : ""}>{pageNumber}</button>
//             ))}
//             <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
//           </div>
//         </div>
//       )}

//       {isModalOpen && selectedStation && (
//         <ConfigureStationModal
//           station={selectedStation}
//           onClose={handleCloseModal}
//         />
//       )}
//     </div>
//   );
// };

// export default AddStationsTable;







import React, { useState, useEffect, useMemo } from "react";
import Loader from "../../Shared/Loader";

import "../../../css/AddStationsTable.css";
import api from "../../../api/axiosConfig";
import ConfigureStationModal from "./ConfigureStationModal";

// --- Interfaces ---
interface Station {
  id: string;
  appointmentId: string;
  centerId: string;
  centerName: string;
  centerType: string;
  city: string;
  startDate: string;
  endDate: string;
  status: string;
  slotDesigns: Record<string, string>;
}

interface SlotClusterItem {
  _id: string;
  appointment_cluster_id: string;
  center_id: string;
  start_date: string;
  end_date: string;
  weekday_template_map: Record<string, string>;
}

interface SlotClusterResponse {
  page: number;
  limit: number;
  total: number;
  items: SlotClusterItem[];
}

interface CenterDetails {
  name: string;
  centerType: string;
  city: string;
}

interface ConfigResponse {
  success: boolean;
  data: {
    _id: string;
    status: string;
  };
}

// NEW: Interface for the Template API response
interface SlotTemplateResponse {
  template: {
    _id: string;
    name: string;
    created_on: string;
  };
  slots: any[]; // We don't need the specific slots details here, just the name
}

const AddStationsTable = () => {
  const [stations, setStations] = useState<Station[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStation, setSelectedStation] = useState<Station | null>(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    const fetchStationsData = async () => {
      setLoading(true);
      try {
        const token = sessionStorage.getItem("accessToken");
        if (!token) throw new Error("Authentication token not found.");

        // 1. Get Clusters
        const clusterRes = await api.appointment_api.get<SlotClusterResponse>("/api/cluster/clusters", {
          headers: { Authorization: `Bearer ${token}` }
        });
        const clusters: SlotClusterItem[] = clusterRes.data.items || [];

        const uniqueCenterIds = Array.from(new Set(clusters.map(c => c.center_id)));

        if (clusters.length === 0) {
          setStations([]);
          setLoading(false);
          return;
        }

        // 2. Fetch Center Details and Config Status in Parallel
        const centerDetailPromises = uniqueCenterIds.map(id =>
          api.center_api.get<{ success: boolean, data: CenterDetails }>(`/api/v1/centers/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          })
        );

        // Map through individual clusters to pass both centerId AND appointmentClusterId
        const configPromises = clusters.map(async (cluster) => {
          try {
            const res = await api.center_api.get<ConfigResponse>(
              `/api/v1/center/${cluster.center_id}/config?appointmentClusterId=${cluster.appointment_cluster_id}`, 
              { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data && res.data.data && res.data.data.status) {
              return {
                key: `${cluster.center_id}-${cluster.appointment_cluster_id}`,
                status: res.data.data.status
              };
            }
            return { key: `${cluster.center_id}-${cluster.appointment_cluster_id}`, status: "Not Configured" };
          } catch (err) {
            return { key: `${cluster.center_id}-${cluster.appointment_cluster_id}`, status: "Not Configured" };
          }
        });

        const [centerResponses, configStatuses] = await Promise.all([
          Promise.all(centerDetailPromises),
          Promise.all(configPromises)
        ]);

        const centerDataMap = new Map<string, CenterDetails>();
        centerResponses.forEach((res, i) => {
          if (res.data?.success) {
            centerDataMap.set(uniqueCenterIds[i], res.data.data);
          }
        });

        const configStatusMap = new Map<string, string>();
        configStatuses.forEach((item) => {
          configStatusMap.set(item.key, item.status);
        });

        // 3. Fetch Template Names
        const uniqueTemplateIds = new Set<string>();

        clusters.forEach(cluster => {
          if (cluster.weekday_template_map) {
            Object.values(cluster.weekday_template_map).forEach(val => {
              if (val && val !== "None" && val.length > 5) {
                uniqueTemplateIds.add(val);
              }
            });
          }
        });

        const idToNameMap: Record<string, string> = {};

        if (uniqueTemplateIds.size > 0) {
          const templateIdsArray = Array.from(uniqueTemplateIds);
          const templatePromises = templateIdsArray.map(id =>
            api.appointment_api.get<SlotTemplateResponse>(`/api/slot-templates/${id}`, {
              headers: { Authorization: `Bearer ${token}` }
            }).catch(() => null)
          );

          const templateResponses = await Promise.all(templatePromises);

          templateResponses.forEach((res, index) => {
            const originalId = templateIdsArray[index];
            if (res && res.data && res.data.template) {
              idToNameMap[originalId] = res.data.template.name;
            } else {
              idToNameMap[originalId] = originalId;
            }
          });
        }

        // 4. Combine Data and Apply Names
        const finalStationsData = clusters.map((cluster) => {
          const centerItem = centerDataMap.get(cluster.center_id);
          
          const statusKey = `${cluster.center_id}-${cluster.appointment_cluster_id}`;
          const statusItem = configStatusMap.get(statusKey) || "Not Configured";

          let rawSlotDesigns: Record<string, string> = {
            Monday: "None", Tuesday: "None", Wednesday: "None",
            Thursday: "None", Friday: "None", Saturday: "None", Sunday: "None",
            ...(cluster.weekday_template_map || {})
          };

          const namedSlotDesigns: Record<string, string> = {};
          Object.entries(rawSlotDesigns).forEach(([day, value]) => {
            if (idToNameMap[value]) {
              namedSlotDesigns[day] = idToNameMap[value];
            } else {
              namedSlotDesigns[day] = value;
            }
          });

          return {
            id: cluster._id,
            appointmentId: cluster.appointment_cluster_id,
            centerId: cluster.center_id,
            centerName: centerItem?.name || "Unknown",
            centerType: centerItem?.centerType || "Unknown",
            city: centerItem?.city || "Unknown",
            startDate: cluster.start_date,
            endDate: cluster.end_date,
            status: statusItem,
            slotDesigns: namedSlotDesigns,
          };
        });

        setStations(finalStationsData);
      } catch (err: any) {
        console.error("Failed to fetch stations data:", err);
        setError(err.message || "Could not load station data.");
      } finally {
        setLoading(false);
      }
    };
    fetchStationsData();
  }, [refreshTrigger]);

  // Derive unique categories and cities for dropdown options
  const uniqueCategories = useMemo(() => {
    const categories = stations
      .map((s) => s.centerType)
      .filter((type): type is string => Boolean(type && type !== "Unknown"));
    return Array.from(new Set(categories));
  }, [stations]);

  const uniqueCities = useMemo(() => {
    const cities = stations
      .map((s) => s.city)
      .filter((city): city is string => Boolean(city && city !== "Unknown"));
    return Array.from(new Set(cities));
  }, [stations]);

  // Combined filtering by search term, category, and city
  const filteredStations = useMemo(() => {
    return stations.filter((station) => {
      const matchesSearch =
        !searchTerm ||
        station.centerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        station.city.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesCategory =
        !selectedCategory || station.centerType === selectedCategory;

      const matchesCity =
        !selectedCity || station.city === selectedCity;

      return matchesSearch && matchesCategory && matchesCity;
    });
  }, [stations, searchTerm, selectedCategory, selectedCity]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedCategory, selectedCity]);

  const totalPages = Math.ceil(filteredStations.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentStationsToDisplay = filteredStations.slice(startIndex, endIndex);

  const getStatusLabel = (status: string) =>
    status === "Configured" ? "Released" : "Not Released";

  const handleRowClick = (station: Station) => {
    setSelectedStation(station);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedStation(null);
  };

  if (loading) return <div className="add-stations-container"><Loader text="Loading stations..." /></div>;
  if (error) return <div className="add-stations-container"><p style={{ color: "red" }}>{error}</p></div>;

  return (
    <div className="add-stations-container">
      <h3 className="add-station-table-title">List of Clusters</h3>
      <div className="table-actions">
        <div className="filter-controls-bar">
          <select
            className="center-filter-dropdown"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Center Category</option>
            {uniqueCategories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          <select
            className="center-filter-dropdown"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
          >
            <option value="">City</option>
            {uniqueCities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Search by Center Name"
            className="search-box"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <table className="add-stations-table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Center Name</th>
            <th>Center Type</th>
            <th>City</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentStationsToDisplay.length > 0 ? (
            currentStationsToDisplay.map((row, index) => {
              const isReleased = row.status === "Configured";
              const statusLabel = getStatusLabel(row.status);

              return (
                <tr
                  key={row.id}
                  onClick={isReleased ? () => handleRowClick(row) : undefined}
                  style={{ cursor: isReleased ? "pointer" : "default" }}
                >
                  <td>{startIndex + index + 1}</td>
                  <td>{row.centerName}</td>
                  <td>
                    <span className={`badge ${row.centerType.toLowerCase().includes("qavach") ? "qavach" : row.centerType.toLowerCase().includes("camp") ? "camp" : "default"}`}>
                      {row.centerType}
                    </span>
                  </td>
                  <td>{row.city}</td>
                  <td>{row.startDate}</td>
                  <td>{row.endDate}</td>
                  <td className={isReleased ? "status-configured" : "status-not"}>{statusLabel}</td>
                  <td className="action-cell">
                    {!isReleased && (
                      <button
                        type="button"
                        className="configure-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRowClick(row);
                        }}
                      >
                        Configure
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr><td colSpan={8} style={{ textAlign: 'center' }}>No stations match your search.</td></tr>
          )}
        </tbody>
      </table>

      {totalPages > 0 && (
        <div className="pagination-footer">
          <p>Showing {startIndex + 1} to {Math.min(endIndex, filteredStations.length)} of {filteredStations.length} results</p>
          <div className="pagination">
            <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}>Previous</button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => (
              <button key={pageNumber} onClick={() => setCurrentPage(pageNumber)} className={currentPage === pageNumber ? "active" : ""}>{pageNumber}</button>
            ))}
            <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
          </div>
        </div>
      )}

      {isModalOpen && selectedStation && (
        <ConfigureStationModal
          station={selectedStation}
          onClose={handleCloseModal}
          onSuccess={() => setRefreshTrigger(prev => prev + 1)}
        />
      )}
    </div>
  );
};

export default AddStationsTable;